import { CLASS_LOCATION_QUERY_KEYS, CLASS_QUERY_KEYS } from '@/constants';
import { createEntityCrudHooks } from './createEntityCrudHooks';

export interface ClassLocation {
  id: string;
  title: string;
  created_by_name: string;
  created_by_email: string;
  created_at: string;
  updated_at: string;
}

export interface CreateClassLocationData {
  title: string;
}

export interface UpdateClassLocationData {
  title: string;
}

const hooks = createEntityCrudHooks<ClassLocation, CreateClassLocationData, UpdateClassLocationData>({
  table: 'class_locations',
  entityType: 'class_location',
  label: 'class location',
  labelPlural: 'class locations',
  pascalName: 'ClassLocation',
  allKey: CLASS_LOCATION_QUERY_KEYS.ALL,
  byId: (id) => CLASS_LOCATION_QUERY_KEYS.BY_ID(id),
  relatedKeysOnDelete: [CLASS_QUERY_KEYS.ALL],
});

export const useClassLocations = hooks.useList;
export const useClassLocation = hooks.useOne;
export const useCreateClassLocation = hooks.useCreate;
export const useUpdateClassLocation = hooks.useUpdate;
export const useDeleteClassLocation = hooks.useDelete;
